import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import '../Styles/Herosection.css';

// Pick just ONE background image
import slide1 from '../Assets/img7.jpg';

const words = [
    'WE CREATE STUNNING WEBSITES',
  'WE CRAFT GREAT USER EXPERIENCE',
  'WE BUILD ROBUST WEB APPLICATION',
  'WE DEVELOP SCALABLE MOBILE APPS',
  'WE ARE GOOGLE CERTIFIED PARTNER',
];

const HeroSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const wordRefs = useRef([]);

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  useEffect(() => {
    wordRefs.current.forEach((ref, index) => {
      if (ref) ref.style.opacity = index === currentWordIndex ? 1 : 0;
    });

    const wordInterval = setInterval(() => {
      const cw = wordRefs.current[currentWordIndex];
      const nextIndex = (currentWordIndex + 1) % words.length;
      const nw = wordRefs.current[nextIndex];

      const cwLetters = cw.children;
      const nwLetters = nw.children;

      for (let i = 0; i < cwLetters.length; i++) {
        cwLetters[i].className = 'letter out';
      }

      for (let i = 0; i < nwLetters.length; i++) {
        nwLetters[i].className = 'letter behind';
        nw.style.opacity = 1;
        setTimeout(() => {
          nwLetters[i].className = 'letter in';
        }, 340 + i * 80);
      }

      setCurrentWordIndex(nextIndex);
    }, 4000);

    return () => clearInterval(wordInterval);
  }, [currentWordIndex]);

  const splitWord = (word, index) => {
    return (
      <span
        key={index}
        className="word"
        ref={(el) => (wordRefs.current[index] = el)}
        style={{ opacity: index === 0 ? 1 : 0 }}
      >
        {word.split('').map((letter, i) => (
          <span key={i} className="letter in">
            {letter === ' ' ? '\u00A0' : letter}
          </span>
        ))}
      </span>
    );
  };

  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${slide1})` }}
    >
      <div
        ref={ref}
        className={`hero-content dark-silver-wrapper ${inView ? 'fade-up' : ''}`}
      >
        <h1 className="dark-silver-text dark-silver-text1 shiny-wrapper">DD DIGITAL CONSTRUCTION</h1>

        <div className="text-animation">
          <p className="dynamic-text">
            {words.map((word, i) => splitWord(word, i))}
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
